import script from "./EnrollStudentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EnrollStudentForm.vue?vue&type=script&setup=true&lang=js"

import "./EnrollStudentForm.vue?vue&type=style&index=0&id=1bed9119&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/Dean_DHSES/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bed9119"]])

export default __exports__